//
//
//
//
//
//
//
//
//
//
//
//
//



export default {

    props: {
        rowguid:{
            type:String,
            default:'',
        },

    },
    components: {},
    data: function () {
        return {
            form: {
                rowguid:this.rowguid,
                chyy:'',
            },


        }
    },
    computed: {

    },
    watch: {


    },

    methods: {
        cancle: function () {
            this.$emit('close');
        },
        submit: function () {
            this.$post(this.getStore('finUrl') + '/receipt/fpch', this.form, (data, res) => {
                this.$emit('close');
                ShowMsg.call(this, res.msg);
            }); 
        },
    },
    mounted () {
      
    }
}
